import React from "react";
import moment from "moment";
// If your base modal is at a different path, fix this import:
import { Modal } from "../Modals/ModalsReceiveable";

const ModalReceiveable = ({ open, onClose, selectedRow, onConfirm }) => {
  const group = selectedRow?.group || [];

  // 👉 Total of all entries in this cheque group
  const totalAmount = group
    .reduce((sum, row) => sum + parseFloat(row?.amount || 0), 0)
    .toFixed(2);

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={`Cheque #${selectedRow?.chequeNumber ?? ""}`}
      //   description="Review all entries for this cheque."
      size="md"
      contentClassName="w-[900px] max-w-[95vw]"
    >
      {selectedRow && (
        <div className="w-[850px] max-w-[95vw] h-fit space-y-4 text-sm text-gray-800">
          {/* Head details */}
          <div className="grid grid-cols-3 gap-2">
            <p className="text-gray-500">Customer</p>
            <p className="col-span-2 font-semibold">
              {selectedRow.customer_name ?? selectedRow.customer ?? "—"}
            </p>

            <p className="text-gray-500">Bank</p>
            <p className="col-span-2">{selectedRow.bank ?? "—"}</p>

            {/* 👉 New: Total for this cheque (sum of all group entries) */}
            <p className="text-gray-500">Total (All Entries)</p>
            <p className="col-span-2 font-semibold">{totalAmount}</p>

            <p className="text-gray-500">Receiving</p>
            <p className="col-span-2">
              {selectedRow.receiving
                ? moment(selectedRow.receiving).format("ll")
                : "—"}
            </p>

            <p className="text-gray-500">Payable</p>
            <p className="col-span-2">
              {selectedRow.payable
                ? moment(selectedRow.payable).format("ll")
                : "—"}
            </p>

            <p className="text-gray-500">Status</p>
            <p className="col-span-2">
              <span
                className={`${
                  selectedRow.status === "CLEARED"
                    ? "bg-green-500 text-green-600"
                    : "bg-red-500 text-red-600"
                } px-2 py-0.5 inline-block text-[10px] rounded-md uppercase bg-opacity-20 font-semibold`}
              >
                {selectedRow.status}
              </span>
            </p>
          </div>

          {/* Group table */}
          {group.length > 0 && (
            <div className="mt-2">
              <p className="text-xs text-gray-500 mb-2">
                All entries for this cheque ({group.length})
              </p>
              <div className="overflow-auto rounded-2xl border border-gray-200">
                <table className="w-full text-xs">
                  <thead className="bg-gray-50 text-gray-600">
                    <tr>
                      <th className="text-left px-3 py-2">Receiving</th>
                      <th className="text-left px-3 py-2">Payable</th>
                      <th className="text-left px-3 py-2">Customer</th>
                      <th className="text-left px-3 py-2">Order</th>
                      <th className="text-left px-3 py-2">Bank</th>
                      <th className="text-right px-3 py-2">Amount</th>
                      <th className="text-center px-3 py-2">Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {group.map((row, i) => (
                      <tr key={i} className="border-t">
                        <td className="px-3 py-2">
                          {row.receiving
                            ? moment(row.receiving).format("ll")
                            : "—"}
                        </td>
                        <td className="px-3 py-2">
                          {row.payable ? moment(row.payable).format("ll") : "—"}
                        </td>
                        <td className="px-3 py-2">
                          {row.customer_name ?? row.customer ?? "—"}
                        </td>
                        <td className="px-3 py-2">{row.order_id || "N/A"}</td>
                        <td className="px-3 py-2">{row.bank ?? "—"}</td>
                        <td className="px-3 py-2 text-right">{row.amount}</td>
                        <td className="px-3 py-2 text-center">
                          <span
                            className={`${
                              row.status === "CLEARED"
                                ? "bg-green-500 text-green-600"
                                : "bg-red-500 text-red-600"
                            } px-2 py-0.5 inline-block rounded bg-opacity-20 font-semibold`}
                          >
                            {row.status}
                          </span>
                        </td>
                      </tr>
                    ))}
                    {/* Optional: a footer row inside the table showing the same total */}
                    <tr className="bg-gray-50 border-t">
                      <td className="px-3 py-2 font-semibold" colSpan={5}>
                        Total
                      </td>
                      <td className="px-3 py-2 text-right font-semibold">
                        {totalAmount}
                      </td>
                      <td></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          )}

          <div className="pt-2 flex items-center justify-end gap-3 pb-6">
            <button
              type="button"
              onClick={onClose}
              className="rounded-lg border border-gray-300 px-3 py-1.5 text-sm text-gray-700 hover:bg-gray-50"
            >
              Close
            </button>
            <button
              type="button"
              className="rounded-lg bg-primary px-3 py-1.5 text-sm font-semibold text-white hover:opacity-90 disabled:opacity-50"
              disabled={selectedRow.status === "CLEARED"}
              onClick={onConfirm}
            >
              Confirm & Clear
            </button>
          </div>
        </div>
      )}
    </Modal>
  );
};

export default ModalReceiveable;
